$(function () {
    $('.slider_mv').slick({
    fade: true,
    autoplay: true,
    centerMode: true,
    arrows: false,
    dots: false,
    speed: 800,
    variableWidth:false,
    });
});

//香り別スライダー
$(function () {
    $('.aroma_itemlist').slick({
    autoplay: true,
    dots: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth:false,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0714/4525/0339/files/page-candle-yc_prev.gif" alt="prev"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0714/4525/0339/files/page-candle-yc_next.gif" alt="next"></button>',
    responsive: [{
        breakpoint: 768,
            settings: {
                slidesToShow: 2,
        }
    }]
    });
});